import React from 'react'
import PropTypes from 'prop-types'

import BasePriceWithDiscount from './BasePriceWithDiscount'
import calculateAddonViewPrices from './calculateAddonViewPrices'

const AddonPrice = ({
  fullPriceInfo,
  qty,
  isAddonSelected,
  isAddonSummary,
  enableUSBAddon,
  productInAddon,
  showEachSuffix,
}) => {
  const { finalPrice, discountLabel, price } = calculateAddonViewPrices({
    fullPriceInfo,
    qty,
    enableUSBAddon,
    productInAddon,
    showEachSuffix,
    isAddonSummary,
  })
  const discountMethod = fullPriceInfo.promo_discount_details?.discount_method

  const showUSBDiscount = enableUSBAddon && !!discountLabel

  const priceLabelClassName = showUSBDiscount ? 'priceLabelWithDiscountAddonUSB' : 'priceLabelWithDiscountAddon'
  const priceClassName = 'priceAddon'
  const discountBoxClassName = showUSBDiscount ? 'discountBoxAddonUSB' : 'discountBoxAddon'
  const discountLabelClassName = showUSBDiscount ? 'discountLabelAddonUSB' : 'discountLabelAddon'

  const mainBoxDirection = showUSBDiscount ? 'row' : 'column'
  const alignMainBox = showUSBDiscount ? 'center' : 'flex-end'
  const justifyMainBox = showUSBDiscount ? 'flex-end' : 'initial'
  return (
    <BasePriceWithDiscount
      finalPrice={finalPrice}
      price={price}
      discountLabel={discountLabel}
      priceLabelClassName={priceLabelClassName}
      discountMethod={discountMethod}
      priceClassName={priceClassName}
      enableUSBAddon={showUSBDiscount}
      discountBoxClassName={discountBoxClassName}
      discountLabelClassName={discountLabelClassName}
      isAddonSummary={isAddonSummary}
      isAddonSelected={isAddonSelected}
      mainBoxDirection={mainBoxDirection}
      alignItemsMainBox={alignMainBox}
      justifyContentMainBox={justifyMainBox}
    />
  )
}

AddonPrice.propTypes = {
  fullPriceInfo: PropTypes.object.isRequired,
  qty: PropTypes.number,
  isAddonSelected: PropTypes.bool,
  isAddonSummary: PropTypes.bool,
  enableUSBAddon: PropTypes.bool,
  productInAddon: PropTypes.bool,
  showEachSuffix: PropTypes.bool,
}

export default AddonPrice
